import React, { useState } from "react";
import { VinSearchCtxProvider } from "components/VinSearch/VinSearchContext";
import { ModuleGeneralVinSearch } from "@carfax/contentful/PageModularModule";
import VinSearch from "components/VinSearch/VinSearch";
import ModalWhereIsVin from "../ModalWhereIsVin";
import { VinSearchComponent } from "@carfax/web-ui/components/VinSearchComponent";
import { VinSearchType } from "@carfax/web-ui/components/VinSearchComponent/utils/useSettings";
import PartnerHeader from "../PartnerHeader";

interface GeneralVinSearchProps {
  module: ModuleGeneralVinSearch;
}

const GeneralVinSearch: React.FC<GeneralVinSearchProps> = ({
  module: {
    header,
    bottomSubtitle,
    placeholder,
    subtitle,
    componentType,
    partnerLogo,
    headerWithoutVin,
    subtitleWithoutVin,
    bottomSubtitleUrl,
    isZoomEnabled,
    isLicensePlateDetection,
  },
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const onClickWhereIsVin = (event: React.MouseEvent) => {
    event.preventDefault();
    setModalOpen(true);
  };

  const vinSearchProps = {
    customPlaceholder: placeholder,
  };

  const vinSearchComponentProps = {
    header: header,
    subtitle: subtitle,
    bottomSubtitle: bottomSubtitle,
    openModal: onClickWhereIsVin,
    componentType: componentType,
    bottomSubtitleUrl: bottomSubtitleUrl,
  };

  const partnerHeaderProps = {
    title: header,
    titleWithoutVin: headerWithoutVin,
    partnerLogo: partnerLogo,
    subtitle: subtitle,
    subtitleWithoutVin: subtitleWithoutVin,
    afterVinCheck: bottomSubtitle,
    isZoomEnabled: isZoomEnabled,
    isLicensePlateDetection: isLicensePlateDetection,
  };

  const renderHeader = () => {
    switch (componentType) {
      case VinSearchType.PARTNER_HEADER_WITH_LOGO:
        return <PartnerHeader module={partnerHeaderProps} />;
      default:
        return renderVinSearchComponent();
    }
  };

  const renderVinSearchComponent = () => {
    return (
      <>
        <VinSearchComponent {...vinSearchComponentProps}>
          <VinSearchCtxProvider>
            <VinSearch {...vinSearchProps} />
          </VinSearchCtxProvider>
        </VinSearchComponent>

        {modalOpen && <ModalWhereIsVin modalOpen={modalOpen} setModalOpen={setModalOpen} />}
      </>
    );
  };

  return renderHeader();
};

export default GeneralVinSearch;
